var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"github-button",attrs:{"href":"https://github.com/Andresws12/Acciona-Project","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{attrs:{"src":require("@/assets/github.svg"),"alt":"Github"}})])
}]

export { render, staticRenderFns }